import React from 'react';
import { STRIPE_BROWSER_FALLBACK_URL } from '../utils/stripeLoader';

const DARK = '#1a1a2e';
const GOLD = '#C9A84C';

/** Shown in StripeCheckoutSlideout when Stripe.js fails to load. */
export default function StripeLoadErrorPanel({ message, onRetry }) {
  return (
    <div style={{ padding: '32px 24px', textAlign: 'center' }}>
      <p style={{ fontSize: 15, fontWeight: 700, color: '#c0392b', margin: '0 0 10px' }}>
        {message || 'Failed to load Stripe.js'}
      </p>
      <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6, margin: '0 0 20px' }}>
        Trouble loading the payment form? Open{' '}
        <a href={STRIPE_BROWSER_FALLBACK_URL} style={{ color: GOLD, fontWeight: 600 }}>
          maestrodesktop.com
        </a>
        {' '}in your browser to subscribe.
      </p>
      <button
        type="button"
        onClick={onRetry}
        style={{
          padding: '12px 24px', borderRadius: 12, border: 'none',
          background: GOLD, color: DARK, fontSize: 14, fontWeight: 700, cursor: 'pointer',
        }}
      >
        Retry
      </button>
    </div>
  );
}
